import {HTMLProps} from 'react';
import {Page} from '../../common/constant/page';
import useTypedSelector from '../../common/hook/useTypedSelector';

interface IProps extends HTMLProps<HTMLDivElement> {}

export default function EventMaxWidthV4({className, ...rest}: IProps) {
  const isDevPage = useTypedSelector(
    state => state.common.layoutProps?.page === Page.Dev
  );
  return (
    <div
      className={
        isDevPage
          ? cn('px-18', className)
          : cn(
              'w-full relative px-18 mx-auto',
              'md:w-default-medium-max-width lg:w-default-max-width',
              className
            )
      }
      {...rest}
    />
  );
}
